export default {
  price_estimation: {
    title: 'Gayrimenkul Değerlendirmesi',
    summary_title: 'Özet Göstergeler',
    avg_label: 'Ortalama Fiyat',
    median_label: 'Medyan Fiyat',
    models_title: 'Estimator24 Modelleri',
    not_ready: 'Değerlendirme henüz yapılmadı',
    ai_prediction: 'Yapay Zeka Değerlendirmesi',
    market_range: 'Piyasa',
    price_label: 'Emlak Fiyatı',
    within_range: 'Piyasa aralığında',
    above_range: '+{percent}% fazla fiyatlı',
    below_range: '−{percent}% piyasa altı'
  }
}
